// Import general mixin for shared functionality.
import mixin from './mixin';

import SourceSet from './components/SourceSet.vue';

// Fuzzy search module
import Fuse from 'fuse.js';

const fuseOptions = {
    shouldSort: false,
    keys: [
        'Name',
        'Title',
        'Doelgroep'
    ]
};

const ShopOverviewApp = {
    mixins: [mixin],
    components: { SourceSet },
    data() {
        return {
            dataJson: null,
            items: [],
            dataGroups: [],
            dataLimit: 12,
            dataGrouplabel: '',
            dataSortinglabel: 'Sortering',
            dataStandardlabel: 'van A tot Z',
            dataIncreasinglabel: 'prijs oplopend',
            dataDecreasinglabel: 'prijs aflopend',
            filterGroups: [],
            searchText: '',
            page: 0,
            sorting: 'van A tot Z',
            cart: [],
        }
    },
    computed: {
        filteredItems() {
            if (!this.items) return [];
            let filtered = [...this.items];

            if (this.filterGroups.length) filtered = filtered.filter(item => this.filterOnGroup(item));

            if (this.searchText) {
                const fuse = new Fuse(filtered, fuseOptions);
                const results = fuse.search(this.searchText);
                filtered = results.map(result => result.item);
            }

            return filtered;
        },
        groups() {
            if (!this.dataGroups || !this.items || !this.items.length) return [];
            return this.dataGroups.filter(doelgroep => {
                return this.items.some(item => item.Doelgroep === doelgroep.Naam) ||
                    doelgroep.Subdoelgroepen.some(subdoelgroep => this.items.some(item => item.Doelgroep === subdoelgroep.Naam))
            });
        },
        sortingOptions() {
            return [this.dataStandardlabel, this.dataIncreasinglabel, this.dataDecreasinglabel];
        },
        sortedItems() {
            switch (this.sorting) {
                case this.dataStandardlabel:
                    return [...this.filteredItems].sort((a, b) => a.Title.localeCompare(b.Title));
                case this.dataIncreasinglabel:
                    return [...this.filteredItems].sort((a, b) => a.Price - b.Price);
                case this.dataDecreasinglabel:
                    return [...this.filteredItems].sort((a, b) => b.Price - a.Price);
                default:
                    return this.filteredItems;
            }
        },
        limitedItems() {
            return this.sortedItems.slice(0, (this.page + 1) * this.dataLimit);
        },
    },
    methods: {
        init() {
            if (this.$el.dataset.json) this.dataJson = JSON.parse(this.$el.dataset.json);
            if (this.dataJson.SubPages) this.items = this.dataJson.SubPages;
            if (this.dataJson.Doelgroepen) this.dataGroups = this.dataJson.Doelgroepen;
            if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
            if (this.$el.dataset.sortinglabel) this.dataSortinglabel = this.$el.dataset.sortinglabel;
            if (this.$el.dataset.standardlabel) this.dataStandardlabel = this.$el.dataset.standardlabel;
            if (this.$el.dataset.standardlabel) this.sorting = this.$el.dataset.standardlabel;
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('sorting')) this.sorting = urlParams.get('sorting');
            if (this.$el.dataset.increasinglabel) this.dataIncreasinglabel = this.$el.dataset.increasinglabel;
            if (this.$el.dataset.decreasinglabel) this.dataDecreasinglabel = this.$el.dataset.decreasinglabel;
            if (this.$el.dataset.carturl) this.dataCartUrl = this.$el.dataset.carturl;

            if (urlParams.has('page')) this.page = parseInt(urlParams.get('page'));

            if (localStorage.getItem('cart')) {
                this.cart = JSON.parse(localStorage.getItem('cart'));
            }
            var dataLayerItems = [];

            this.items.forEach((item) =>
                dataLayerItems.push({
                    "item_id": item.Key,
                    "item_name": item.Name,
                    "price": this.priceExBtw(item.Price),
                    "quantity": 1
                })
            );
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "view_item_list",
                ecommerce: {
                    items: dataLayerItems
                }
                
            });

        },
        filterOnGroup(item) {
            return this.filterGroups.includes(item.Doelgroep);
        },
        onFilterGroup(groupName) {
            let newFilterGroups = [...this.filterGroups];
            let group = this.groups.find((g) => g.Naam === groupName);
            if (group) {
                let subGroups = group.Subdoelgroepen.map((subGroup) => subGroup.Naam);
                if (newFilterGroups.includes(groupName)) {
                    newFilterGroups = newFilterGroups.filter(
                        (name) => name !== groupName && !subGroups.includes(name)
                    );
                } else {
                    newFilterGroups.push(groupName);
                    subGroups.forEach((subGroupName) =>
                        newFilterGroups.push(subGroupName)
                    );
                }
            } else {
                const index = newFilterGroups.indexOf(groupName);
                if (index > -1) {
                    newFilterGroups.splice(index, 1);
                } else {
                    newFilterGroups.push(groupName);
                }
            }
            this.filterGroups = newFilterGroups;
            const url = new URL(location);
            if (this.filterGroups.length) {
                url.searchParams.set('groups', this.filterGroups.join('+'));
            } else {
                url.searchParams.delete('groups');
            }
            history.pushState({}, '', url);
        },
        loadMore() {
            this.page++;
            this.updateUrl();
        },
        updateUrl() {
            if (!this.page) {
                history.pushState({}, null, window.location.pathname);
                return;
            }
            const urlParams = new URLSearchParams();
            if (this.page) urlParams.append('page', this.page);
            history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
        },
        openDropdown(ref) {
            if (this.$refs[ref]) {
                this.$refs[ref].classList.add('is-active');

                document.addEventListener('click', (event) => {
                    if (!this.$refs[ref].contains(event.target)) {
                        this.$refs[ref].classList.remove('is-active');
                    }
                });
            }
        },
        setSorting(sorting, ref) {
            if (this.$refs[ref]) {
                this.$refs[ref].classList.remove('is-active');
            }
            this.sorting = sorting;
            const url = new URL(location);
            url.searchParams.set('sorting', this.sorting);
            if (this.sorting === this.dataStandardlabel) url.searchParams.delete('sorting');
            history.pushState({}, '', url);
        },
        download(url, name) {
            var link = document.createElement('a');
            link.setAttribute('download', name);
            link.href = url;
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
        addToCart(item) {
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "add_to_cart",
                ecommerce: {

                    currency: "EUR",
                    value: this.priceExBtw(item.Price),
                    items: [
                        {
                            item_id: item.Key,
                            item_name: item.Name,
                            price: this.priceExBtw(item.Price),
                            quantity: 1
                        }
                    ]
                }
            });

            if (this.cart.find(product => product.id === item.Key)) {
                this.cart.find(product => product.id === item.Key).amount++;
            }
            else {
                this.cart.push({
                    id: item.Key,
                    name: item.Name,
                    price: item.Price,
                    imagesrc: item.ThumbnailImageSrc,
                    imagecrops: item.ThumbnailImageCrops,
                    focalpoint: item.ThumbnailFocalPoint,
                    url: item.Url,
                    amount: 1,
                });
            }
            
            localStorage.setItem('new', item.Key);
            localStorage.setItem('cart', JSON.stringify(this.cart));
            window.location.href = this.dataCartUrl;
        }
    },
    created() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.has('sorting')) this.sorting = urlParams.get('sorting');
        if (urlParams.has('q')) this.searchText = urlParams.get('q');
        if (urlParams.has('groups')) this.filterGroups = urlParams.get('groups').split('+');

        this.changeSearchText = this.debounce(event => {
            const url = new URL(location);
            url.searchParams.set('q', this.searchText);
            if (!this.searchText) url.searchParams.delete('q');
            history.pushState({}, '', url);
        });
    },
    mounted() {
        this.init();
    },
};

export default ShopOverviewApp;
